var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHollowInfo = function SvgHollowInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm-9-7a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm10-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-2 7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2v-4a1 1 0 0 0-1-1h-1a1 1 0 1 0 0 2v3Z",
    clipRule: "evenodd"
  })));
};
export default SvgHollowInfo;